/**
 * Searchable autocomplete dropdown (react-select).
 * Use isCreatable when the user may type a value not in the list (e.g. district).
 */
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

const DEFAULT_STYLES = {
  menuPortal: (base) => ({ ...base, zIndex: 2200 }),
  menu: (base) => ({ ...base, zIndex: 2200 }),
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(13, 110, 253, 0.25)' : 'none',
    fontSize: 14,
  }),
};

export default function SearchableSelect({
  options = [],
  value = '',
  onChange,
  placeholder = 'Select…',
  isClearable = true,
  isCreatable = false,
  isDisabled = false,
  inputId,
  name,
  noOptionsMessage = 'No matches',
  classNamePrefix = 'ps-search-select',
}) {
  const normalizedOptions = Array.isArray(options) ? options : [];
  const stringValue = value === 0 || value ? String(value) : '';
  let selected = normalizedOptions.find((opt) => String(opt.value) === stringValue) || null;
  if (!selected && stringValue) {
    selected = { value: stringValue, label: stringValue };
  }

  const Component = isCreatable ? CreatableSelect : Select;

  return (
    <Component
      inputId={inputId}
      classNamePrefix={classNamePrefix}
      name={name}
      isSearchable
      isClearable={isClearable}
      isDisabled={isDisabled}
      placeholder={placeholder}
      options={normalizedOptions}
      value={selected}
      onChange={(option) => onChange(option ? option.value : '')}
      noOptionsMessage={() => noOptionsMessage}
      formatCreateLabel={(input) => `Use "${input}"`}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      menuPosition="fixed"
      styles={DEFAULT_STYLES}
    />
  );
}
